import convertFormData from '@module/utils/convertFormData';

import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type {
  AddVoteParams,
  AddVoteResponse,
  AttendVoteParams,
  AttendVoteResponse,
  DeleteVoteParams,
  DeleteVoteResponse,
  EditVoteParams,
  EditVoteResponse,
  EndVoteParams,
  EndVoteResponse,
  GetVoteInfo,
  PresignedPost,
  PresignedPostResponse,
  TopFixedVoteParams,
  TopFixedVoteResponse,
  VoteInfoParams,
} from './type';

export const addVote = async (addVoteParams: AddVoteParams) => {
  const res = await fetchExtended(`/v1/vote/add`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(addVoteParams),
  });

  const result = await res.json();

  return result as AddVoteResponse;
};

export const editVote = async (editVoteParams: EditVoteParams) => {
  const res = await fetchExtended(`/v1/vote/edit`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(editVoteParams),
  });

  const result = await res.json();

  return result as EditVoteResponse;
};

export const fetchVoteInfo = async (voteInfoParams: VoteInfoParams) => {
  const res = await fetchExtended(`/v1/vote/get`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(voteInfoParams),
  });

  const result = await res.json();

  return result as GetVoteInfo;
};

export const attendVote = async (attendVoteParams: AttendVoteParams) => {
  const res = await fetchExtended(`/v1/vote/attend`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(attendVoteParams),
  });

  const result = await res.json();

  return result as AttendVoteResponse;
};

export const endVote = async (endVoteParams: EndVoteParams) => {
  const res = await fetchExtended(`/v1/vote/end`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(endVoteParams),
  });

  const result = await res.json();

  return result as EndVoteResponse;
};

export const deleteVote = async (deleteVoteParams: DeleteVoteParams) => {
  const res = await fetchExtended(`/v1/vote/delete`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(deleteVoteParams),
  });

  const result = await res.json();

  return result as DeleteVoteResponse;
};

export const presignedPost = async (params: PresignedPost) => {
  const res = await fetchExtended(`/v1/file/presignedPost`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as PresignedPostResponse;
};

export const topFixedVote = async (topFixedVoteParams: TopFixedVoteParams) => {
  const res = await fetchExtended(`/v1/vote/top`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(topFixedVoteParams),
  });

  const result = await res.json();

  return result as TopFixedVoteResponse;
};
